import ArticleLayout from '@/pages/article/components/ArticleLayout';
import { allArticles } from '@/mocks/articles';

export default function SugargooReviewPage() {
  const article = allArticles.find(a => a.slug === 'sugargoo-review')!;
  return <ArticleLayout article={article} />;
}